var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulherCelularHomem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 649.19 563.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke: #263238;\n      }\n\n      .cls-1, .cls-6 {\n        fill: #88bd28;\n      }\n\n      .cls-7, .cls-3, .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-10, .cls-4 {\n        fill: none;\n      }\n\n      .cls-11 {\n        opacity: .7;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5, .cls-14 {\n        fill: #263238;\n      }\n\n      .cls-8 {\n        isolation: isolate;\n        opacity: .2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m521.41,286.29s-52.53,16.28-62.41,3.42l1.34-65.58h7.97l9.37,46.2,43.05-7.88s5.52,17.09.68,23.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m516.26,288.01l9.22,56.79c-.24,36.81,17.32,31.28,29.51,31.17,14.09-.12,35.48-14.09,24.99-35.84l4.04-78.72-24.55-1.87c-8.09-.63-41.25.41-43.89,4.64-6.84,10.99.68,23.83.68,23.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m607.16,296.92c-3.68-5.36-6.4-11.33-8.02-17.63-.59-3.16-1.51-6.24-2.74-9.21-2.36-4.64-6.76-7.91-11.89-8.82-1.08-.24-2.2-.19-3.26.15-2.19.83-3.15,3.35-3.59,5.64-.95,4.92-.67,10,.81,14.79,1.01,3.26,13.14,26.86,21.1,36.01-.69-4.61,4.61-20.03,7.58-20.92Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-423"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m81.09,119.37C186.7-.8,368.02-20.8,448.86,17.8c31.41,14.88,60.46,34.3,86.23,57.62,3.38,3.01,6.66,6.11,9.84,9.3,9.95,9.8,19.27,20.2,27.93,31.15,10.37,13.1,19.73,26.98,27.99,41.51,11.83,20.68,21.21,42.67,27.93,65.52,4.45,15,7.37,30.4,8.71,45.99,2.31,29.26.3,58.78-3.63,87.8-.36,2.77-.75,5.55-1.18,8.32-.11.77-.21,1.51-.33,2.31-4.33,28.89-10.45,58.04-24.12,83.24-14.92,27.54-66.98,103.94-123.44,105.91-29.29,1.04-55.15-18.09-81.69-31.65-42.2-21.52-89.97-25.74-136.54-26.99s-93.72.09-139.1-11.45c-45.38-11.55-89.88-38.06-113.07-82.13-7.88-14.98-13.87-36.57-13.88-53.84,0-50.96,8.32-95.53,22.85-134.25,4.61-12.35,10-24.39,16.11-36.07,8.96-17.12,19.52-33.35,31.53-48.49l10.1-12.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m81.09,119.37C186.7-.8,368.02-20.8,448.86,17.8c31.41,14.88,60.46,34.3,86.23,57.62,3.38,3.01,6.66,6.11,9.84,9.3,9.95,9.8,19.27,20.2,27.93,31.15,10.37,13.1,19.73,26.98,27.99,41.51,11.83,20.68,21.21,42.67,27.93,65.52,4.45,15,7.37,30.4,8.71,45.99,2.31,29.26.3,58.78-3.63,87.8-.36,2.77-.75,5.55-1.18,8.32-.11.77-.21,1.51-.33,2.31-4.33,28.89-10.45,58.04-24.12,83.24-14.92,27.54-66.98,103.94-123.44,105.91-29.29,1.04-55.15-18.09-81.69-31.65-42.2-21.52-89.97-25.74-136.54-26.99s-93.72.09-139.1-11.45c-45.38-11.55-89.88-38.06-113.07-82.13-7.88-14.98-13.87-36.57-13.88-53.84,0-50.96,8.32-95.53,22.85-134.25,4.61-12.35,10-24.39,16.11-36.07,8.96-17.12,19.52-33.35,31.53-48.49l10.1-12.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-423"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 0.5,
    y1: 554.72,
    x2: 648.69,
    y2: 554.72
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-423"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m499.33,336.06h0v.17c0,.27.06.56.18.86.67,3.3,1.18,6.64,1.51,9.99.29,2.88.51,6.16.57,9.83.14,8.46-.44,16.93-1.73,25.29-.33,2.2-.72,4.52-1.19,6.84-.74,3.83-1.64,7.84-2.76,11.98-.5,1.93-1.07,3.9-1.67,5.89l-.71,2.43c-.27.98-.54,1.96-.8,3.01h0c-1.73,6.7-3.12,13.48-4.14,20.32-1.28,8.52-2.08,16.97-2.52,24.97-.59,10.67-.56,20.53-.3,28.64,0,.14,0,.27,0,.41.27,8.24.78,14.71,1.13,18.39.2,2.16.33,3.38.35,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m499.38,336.27h0c-2.26-2.01-4.98-3.42-7.91-4.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 501.07,
    y1: 347.13,
    x2: 505.08,
    y2: 343.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m495.96,401.04h0c-.21-1.06-.52-2.09-.93-3.09-.59-1.46-1.4-2.83-2.4-4.05-.74-.92-1.59-1.76-2.52-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m492.75,412.34c1.15-2.85,3.42-5.09,6.29-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m485.78,468.41c1.34-1.63,2.35-7.79,2.89-11.11.14-.78.24-1.51.35-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m475.46,479.6c.45-.05.9-.05,1.34,0,4.02.39,7.5,2.97,9.04,6.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m498.72,389.16s.71-24.46-12.72-33.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m499.86,441.6c1.76,5.71-10.55,16.58-10.55,16.58,0,0-16.26-2.03-18.09-7.73-1.82-5.7,2.35-15.07,10.25-17.48s16.69,2.92,18.39,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m513.56,372.37c-1.51,6.03-13.2,10.35-13.2,10.35,0,0-8.03-9.39-6.53-15.45,1.51-6.06,8-12.72,13.46-11.32,5.46,1.4,7.84,10.35,6.27,16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m466.85,462.91c7.31,2.83,11.79,15.77,11.79,15.77,0,0-12.06,6.5-19.35,3.65-7.29-2.85-15.07-10.87-12.96-16.22,2.11-5.35,13.22-6.1,20.53-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m482.87,391.77c1.48,1.24,3.18,2.2,5,2.83,1.87.61,3.92.12,5.32-1.27,1.51-1.79,1.15-4.52.17-6.77-1.96-4.3-9.16-11.61-14.7-9.51-7.99,3.06.65,12.1,4.21,14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m499.23,402.73c-1.06,1.3-2.17,2.94-1.58,4.52.67,1.37,2.18,2.11,3.68,1.81,1.45-.34,2.8-1.01,3.95-1.94,2.82-1.96,8.61-6.03,4.91-9.9s-8.82,2.79-10.96,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m475.64,348.06c-1.25.07-2.31.93-2.64,2.14-.24,1.4.92,2.62,2.03,3.48,2.8,2.17,11.23,7.99,13.1,2.37,1.78-5.31-8.79-8.4-12.49-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m491.15,329.58c-1.73.17-3.47-.47-5.22-.36-1.75.11-3.66,1.51-3.29,3.23s2.32,2.1,3.92,2.19c2.75.18,5.51-.01,8.21-.56.64-.06,1.23-.36,1.66-.84.71-1.04-.41-2.43-1.61-2.79-1.24-.16-2.46-.46-3.63-.87h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m508.12,341.53c1.73,0,3.42-.69,5.17-.71s3.77,1.27,3.48,3.01-2.16,2.25-3.75,2.44c-2.73.36-5.5.36-8.23,0-.65-.01-1.26-.28-1.72-.74-.77-.98.26-2.44,1.42-2.89,1.23-.23,2.43-.6,3.57-1.1l.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m506.4,469.98c.4-.42.93-.68,1.51-.74.8.08,1.43.71,1.51,1.51.08.74,0,1.5-.27,2.2-1.19,3.96-14.45,32.59-17.51,27.45-1.79-3.01,2.64-13.1,3.95-15.95,2.5-5.56,6.2-10.5,10.82-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m499.94,337.92s-.8-6.95.87-7.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m498.46,330.67c.85-2.45,2.33-4.64,4.28-6.36,2.1-1.51,5.46-1.63,6.98.47,1.7,2.34,0,5.88-2.61,7.13-2.61,1.25-5.68.87-8.55.47v-1.27l-.11-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m505.6,554.37h0c-14.21,2.4-28.72,2.4-42.93,0h0l-16.7-49.27h76.33l-16.7,49.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.32,198.39h0v.17c.06.27.12.56.18.86.68,3.3,1.19,6.64,1.51,9.99.29,2.88.5,6.16.57,9.83.15,8.44-.41,16.88-1.69,25.23-.33,2.2-.72,4.52-1.19,6.84-.74,3.83-1.66,7.84-2.76,11.98-.51,1.93-1.07,3.9-1.67,5.89-.24.81-.48,1.61-.71,2.43s-.56,1.96-.81,3.01h0c-1.73,6.7-3.11,13.48-4.14,20.32-1.28,8.52-2.06,16.97-2.5,24.97-.59,10.67-.57,20.53-.3,28.64v.41c.29,8.24.78,14.71,1.15,18.4.18,2.14.33,3.36.33,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m214.35,198.6h0c-1.08-.95-2.26-1.77-3.53-2.46-1.39-.73-2.87-1.29-4.4-1.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 216.03,
    y1: 209.46,
    x2: 220.06,
    y2: 205.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.94,263.37h0c-.22-1.06-.53-2.09-.95-3.09-.59-1.46-1.4-2.83-2.4-4.05-.74-.92-1.59-1.76-2.52-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.73,274.61c1.14-2.85,3.41-5.09,6.27-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m200.75,330.74c1.34-1.63,2.37-7.79,2.91-11.11.12-.78.24-1.51.33-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m190.43,341.87c.45-.05.91-.05,1.36,0,4.02.4,7.49,2.98,9.04,6.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.68,251.43s.72-24.46-12.72-33.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m214.9,303.93c1.75,5.71-10.55,16.58-10.55,16.58,0,0-16.28-2.03-18.09-7.73-1.81-5.7,2.37-15.07,10.25-17.48s16.62,2.94,18.39,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m228.56,234.7c-1.51,6.03-13.2,10.35-13.2,10.35,0,0-8.12-9.39-6.56-15.45,1.57-6.06,7.99-12.72,13.44-11.32,5.46,1.4,7.82,10.35,6.32,16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m181.84,325.24c7.31,2.85,11.8,15.77,11.8,15.77,0,0-12.06,6.5-19.37,3.65-7.31-2.85-15.07-10.87-12.95-16.22s13.19-6.04,20.51-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m197.86,254.1c1.47,1.24,3.17,2.2,4.99,2.83,1.87.61,3.92.12,5.32-1.27,1.51-1.79,1.15-4.52.17-6.77-1.96-4.3-9.15-11.61-14.7-9.51-7.97,3.03.65,12.07,4.22,14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m214.2,265.07c-1.04,1.3-2.16,3.01-1.58,4.52.67,1.37,2.18,2.11,3.68,1.81,1.45-.34,2.8-1.01,3.95-1.94,2.82-1.94,8.61-6.03,4.91-9.9-3.69-3.87-8.74,2.77-10.96,5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m190.61,210.39c-1.25.08-2.31.94-2.64,2.14-.24,1.4.92,2.62,2.05,3.48,2.8,2.17,11.21,7.99,13.1,2.37,1.76-5.31-8.79-8.4-12.51-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m206.12,191.91c-1.73.17-3.47-.47-5.2-.36s-3.68,1.51-3.29,3.23,2.31,2.1,3.92,2.19c2.75.18,5.5-.01,8.2-.56.64-.06,1.24-.36,1.67-.84.69-1.04-.42-2.43-1.61-2.79-1.24-.16-2.47-.46-3.65-.87l-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m223.09,203.86c1.75,0,3.44-.69,5.17-.71s3.77,1.27,3.5,3.01-2.17,2.25-3.77,2.44c-2.73.36-5.5.36-8.23,0-.65-.01-1.26-.28-1.72-.74-.77-.98.26-2.44,1.43-2.89,1.23-.23,2.43-.6,3.57-1.1l.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m221.37,332.31c.4-.41.93-.68,1.51-.74.79.09,1.41.72,1.51,1.51.08.75-.02,1.5-.29,2.2-1.18,3.96-14.45,32.59-17.5,27.45-1.81-3.01,2.62-13.1,3.93-15.95,2.51-5.56,6.21-10.5,10.84-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.9,200.28s-.8-6.95.89-7.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m213.49,193c.84-2.46,2.32-4.65,4.28-6.36,2.1-1.51,5.44-1.63,6.96.47,1.7,2.34,0,5.88-2.61,7.13-2.61,1.25-5.67.87-8.53.47v-1.27l-.11-.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-423"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.35,
    y1: 365,
    x2: 23.35,
    y2: 216.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 488.33,
    y1: 365,
    x2: 469.93,
    y2: 365
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.65,
    y1: 365,
    x2: 595.16,
    y2: 365
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "468.24 138.75 534.66 138.75 534.66 75.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "81.09 119.43 151.66 119.43 151.66 170.9 229.01 170.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 39.46,
    y1: 293.74,
    x2: 39.46,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.99,
    y1: 130.64,
    x2: 70.99,
    y2: 219.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 102.51,
    y1: 130.64,
    x2: 102.51,
    y2: 209.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.03,
    y1: 130.64,
    x2: 134.03,
    y2: 268.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "285.01 111.09 285.01 20.46 413.32 20.46 413.32 111.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "294.41 65.49 294.41 31.23 318.13 31.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "323.35 65.49 323.35 31.23 347.07 31.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "352.29 65.49 352.29 31.23 376.01 31.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "381.23 65.49 381.23 31.23 404.95 31.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "294.41 111.09 294.41 76.83 318.13 76.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "323.35 111.09 323.35 76.83 347.07 76.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "352.29 111.09 352.29 76.83 376.01 76.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "381.23 111.09 381.23 76.83 404.95 76.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 544.94,
    y1: 83.32,
    x2: 544.94,
    y2: 196.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 591.53,
    y1: 356.68,
    x2: 595.16,
    y2: 356.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.87,
    y1: 115.93,
    x2: 572.87,
    y2: 243.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "600.82 324.22 600.82 356.68 623.11 356.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 600.82,
    y1: 157.38,
    x2: 600.82,
    y2: 243.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "628.74 222.9 628.74 356.68 633.82 356.68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-423"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 367.73,
    width: 287.88,
    height: 186.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: ".5 367.73 144.44 461.22 288.38 367.73 .5 367.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 101.17,
    y1: 433.11,
    x2: 0.5,
    y2: 554.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 188.5,
    y1: 433.11,
    x2: 289.17,
    y2: 554.72
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-423"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m442.44,129.14h-66.92c-3.93,0-7.54,2.14-9.44,5.58h0c-5.09,9.18-16.65,12.5-25.84,7.41-3.12-1.73-5.69-4.3-7.41-7.41h0c-1.88-3.48-5.52-5.65-9.48-5.65h-66.85c-7.72-.1-14.05,6.07-14.15,13.79,0,0,0,0,0,0v377.44c.11,7.71,6.44,13.88,14.15,13.79h185.93c7.72.09,14.05-6.08,14.17-13.79V142.93c-.11-7.72-6.45-13.89-14.17-13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m463.13,138.75c.03-10.67-8.59-19.35-19.26-19.38-.02,0-.04,0-.06,0h-188.66c-10.66,0-19.31,8.63-19.32,19.29v.02h0v396.69c0,10.66,8.64,19.31,19.31,19.31h188.68c10.67,0,19.31-8.64,19.32-19.31h0V138.75Zm-6.53,381.54c-.12,7.72-6.45,13.88-14.17,13.79h-185.93c-7.71.09-14.05-6.08-14.15-13.79V142.93c.1-7.72,6.43-13.89,14.15-13.79,0,0,0,0,0,0h66.88c3.95,0,7.59,2.17,9.47,5.65h0c5.09,9.18,16.65,12.5,25.84,7.41,3.12-1.73,5.69-4.3,7.41-7.41h0c1.89-3.44,5.51-5.58,9.44-5.58h66.92c7.72-.1,14.05,6.07,14.15,13.79,0,0,0,0,0,0v377.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "399.03 119.43 273.7 554.7 323.47 554.66 444.15 119.43 399.03 119.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "380.34 119.43 247.84 554.72 255.09 554.67 385.1 119.43 380.34 119.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m383.28,443.02c.38,17.86-13.78,32.65-31.64,33.03-.27,0-.54,0-.81,0-18.31-.07-33.23-14.73-33.61-33.04-.37-17.86,13.8-32.64,31.66-33.02.26,0,.53,0,.79,0,18.31.06,33.23,14.72,33.61,33.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.42,467.68c-3.07-1.13-5.88-2.87-8.27-5.09-2.41-2.32-4.28-5.15-5.47-8.27-1.35-3.51-2.02-7.24-1.97-11-.02-3.21.55-6.39,1.67-9.39,1.02-2.77,2.56-5.33,4.52-7.54,3.87-4.24,8.88-7.28,14.42-8.77,2.72-.73,5.53-1.1,8.35-1.1,2.34-.01,4.68.27,6.95.83,2.19.54,4.29,1.41,6.22,2.58,1.91,1.15,3.63,2.6,5.08,4.3,1.51,1.83,2.67,3.92,3.41,6.18.85,2.57,1.26,5.27,1.24,7.97-.03,5.23-1.92,10.28-5.32,14.26-1.46,1.66-3.2,3.06-5.12,4.14-1.66.95-3.54,1.47-5.46,1.51-1.32.02-2.62-.4-3.68-1.19-1.08-.8-1.72-2.06-1.73-3.41-2.01,3.06-5.46,4.85-9.12,4.75-2.87.13-5.64-1.05-7.54-3.2-1.88-2.19-2.88-5-2.79-7.88.01-2.37.43-4.73,1.22-6.96.79-2.25,1.91-4.38,3.33-6.3,1.41-1.89,3.21-3.46,5.28-4.6,2.06-1.17,4.4-1.77,6.77-1.76,1.65-.02,3.27.38,4.73,1.15,1.42.75,2.56,1.93,3.29,3.36l.3-1.01c.5-1.47,2.1-2.26,3.57-1.76.27.09.53.23.77.39.46.36.71.92.68,1.51,0,.28-.05.56-.14.83l-4.88,16.25c-.43,1.24-.71,2.52-.83,3.83-.15.82.39,1.6,1.21,1.76.19.04.39.03.59,0,1.73-.11,3.35-.88,4.52-2.16,1.63-1.61,2.88-3.56,3.66-5.71.94-2.35,1.42-4.86,1.42-7.39.02-2.23-.31-4.44-.96-6.57-.55-1.83-1.43-3.55-2.59-5.08-1.1-1.39-2.43-2.58-3.93-3.51-1.5-.95-3.14-1.65-4.85-2.1-1.76-.46-3.57-.7-5.4-.69-2.31,0-4.61.33-6.83.96-2.29.65-4.46,1.63-6.47,2.91-2.02,1.27-3.84,2.83-5.43,4.61-1.63,1.88-2.9,4.05-3.74,6.39-.95,2.55-1.42,5.25-1.4,7.97-.05,3.22.53,6.42,1.72,9.42,1.02,2.59,2.63,4.92,4.7,6.78,2,1.74,4.31,3.08,6.81,3.96,2.64.93,5.42,1.4,8.21,1.39,2.99,0,5.96-.45,8.82-1.34.29-.1.59-.15.89-.15.57,0,1.12.23,1.51.65.39.4.6.95.59,1.51.07.91-.53,1.73-1.42,1.93-3.56,1.09-7.25,1.66-10.97,1.69-3.46,0-6.88-.62-10.13-1.81Zm12.45-15.63c1.49-1.07,2.6-2.59,3.15-4.34l3.15-11.08-.21-.45c-.2-.36-.43-.7-.71-1.01-.38-.44-.79-.84-1.24-1.21-.56-.45-1.2-.8-1.88-1.04-1.78-.62-3.74-.55-5.47.2-.95.4-1.82.97-2.58,1.67-.78.73-1.48,1.55-2.08,2.44-.6.93-1.1,1.91-1.51,2.94-.42,1.03-.75,2.09-.98,3.18-.23,1.03-.34,2.09-.35,3.15-.01.68.03,1.36.12,2.03.07.6.2,1.19.39,1.76.17.53.4,1.04.71,1.51.27.42.62.79,1.02,1.09.43.31.92.54,1.43.68.6.18,1.23.26,1.85.24,1.89.02,3.73-.58,5.23-1.72l-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m382.54,329.78c.37,17.86-13.8,32.64-31.66,33.02-.26,0-.53,0-.79,0-18.31-.06-33.23-14.72-33.61-33.02-.39-17.85,13.76-32.64,31.61-33.03.28,0,.56,0,.84,0,18.31.07,33.23,14.73,33.61,33.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m370.24,326.76c-10.35-6.78-30.66-6.78-40.53,0-3.73.7-6.39,4.03-6.24,7.82.15,4.39,18.37,4.39,18.22,0-.09-1.83-.79-3.58-1.99-4.97,6.83-1.48,13.91-1.48,20.74,0-1.11,1.41-1.69,3.18-1.63,4.97.15,4.39,18.37,4.39,18.21,0-.18-3.86-2.98-7.1-6.78-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m382.54,219.78c.18,8.12-4.25,15.39-11.36,20.23v19.73l-14.15-14.17c-2.29.41-4.61.61-6.93.6-18.24,0-33.29-11.82-33.61-26.39-.32-14.57,14.2-26.38,32.45-26.38s33.37,11.88,33.61,26.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m335.44,219.78c0,2.36-1.9,4.29-4.27,4.3s-4.29-1.9-4.3-4.27c0-2.36,1.9-4.29,4.27-4.3,0,0,.01,0,.02,0,2.36,0,4.27,1.91,4.28,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.75,219.78c0,2.36-1.9,4.29-4.27,4.3s-4.29-1.9-4.3-4.27c0-2.36,1.9-4.29,4.27-4.3,0,0,.01,0,.02,0,2.36,0,4.27,1.91,4.28,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.06,219.78c0,2.36-1.9,4.29-4.27,4.3s-4.29-1.9-4.3-4.27c0-2.36,1.9-4.29,4.27-4.3,0,0,.01,0,.02,0,2.36,0,4.27,1.91,4.28,4.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-423"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.95,279.93c-.53,1-1.31,1.84-2.25,2.47-6.95,5.55-14.07,10.87-21.34,15.96-2.67,1.87-5.44,3.8-8.02,5.89-15.49,10.37-6.03,12.9-15.49,34.85h0c-2.23,5.25-1.82,30.94-1.82,30.94h-.77c-1.81-1.79-3.74-3.46-5.77-5h0c-.28-.19-.57-.36-.87-.51h0c-.28-.15-.59-.24-.9-.29-1.51-.09-7.25.6-13.05.23l-1.51-.12c-.84-.09-1.67-.2-2.5-.35s-1.63-.32-2.4-.53c-5.51-1.77-10.91-3.85-16.17-6.24h0l-2.62-1.13-1.3-.56-1.18-.51-.84-.36-.81-.35h0c-1.37-.57-2.65-1.1-3.83-1.51-.54-.19-1.09-.36-1.64-.5,0,1.24-.2,2.5-.36,3.74-.72,5.89-2.34,11.33-5.22,12.06-.06.02-.12.02-.18,0-.25.05-.51.07-.77.08h-.23c-.64-.01-1.27-.13-1.87-.35h0c-2.61-1.12-4.75-3.12-6.03-5.65-.57-1.07-.89-2.25-.93-3.47,0-4.39-1.22-30.27-1.22-37.8s1.51-20.72,5.26-25.62c1.47-2.08,3.32-3.85,5.46-5.23,2.75-2.29,5.9-4.05,9.3-5.18,4.01-1.31,12.98-4.66,19.23-7.02h0l-9.45,3.65c2.4,4.1,7.54,10.55,16.81,11.38,8.71.74,14.11-7.14,16.87-12.9.24.09,15.4-2.79,18.92-2.62,11.44.5,20.77-5.7,24.99-8.15,4.67-2.79,10.71-1.27,13.5,3.4.39.65.7,1.34.93,2.06v.14c.66,1.64.7,3.46.11,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.35,280.08h0l-.69-.24.69.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m119.21,376.68c0,.06,0,.12,0,.18-.23.54-.84.79-1.38.56-.07-.03-.14-.07-.2-.11-.69-.39-1.76-2.91-1.76-2.91l-1.19-1.24-.78-.83h0c.12.3,1.07,2.61.57,3.68-.03.07-.07.14-.12.2-.68.9-1.74,1.43-2.86,1.43h0c-.65,0-2.55.23-4.21.33h-.18c-.5.03-1.01.03-1.51,0-1.34-.17-2.63-.61-3.8-1.28-2.65-.39-5.26-1.01-7.81-1.85l-.45-.24-.41-.24c-.27-.16-.52-.35-.74-.57-.92-.77-1.7-1.68-2.31-2.71h0s-6.12-.26-14.33-.89c-3.01-.23-6.27-.51-9.65-.84-5.18-.53-9.47-.5-12.83-.96h-.24c-.66-.09-1.28-.21-1.87-.35h0c-2.93-.57-5.27-2.77-6.03-5.65-.2-.67-.36-1.35-.48-2.03l2.62-4.52c1.37-1.1,2.89-1.98,4.52-2.62,2.53-1.06,5.32-1.32,8-.74.56.14,1.1.3,1.64.5,1.18.45,2.46.98,3.83,1.51l.83.35.84.36,1.18.51c6.71,2.77,14.71,6.35,20.06,7.85,1.61.42,3.25.71,4.9.87l1.51.12c5.8.38,11.53-.32,13.05-.23s5.25,3.63,7.63,5.82c.65.6,1.22,1.1,1.61,1.4l.18.15.14.12c.86.89,1.47,1.99,1.75,3.2h0c.12.4.2.82.24,1.24.03.15.04.3.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m119.21,376.68c0,.06,0,.12,0,.18-.23.53-.85.78-1.39.55-.07-.03-.13-.07-.19-.11-.75-.86-1.34-1.85-1.76-2.91l-1.19-1.22-.78-.81h0c.11.24,1.09,2.59.59,3.68-.03.07-.07.14-.12.2-.17.22-.36.42-.57.6-.65.52-1.46.81-2.29.81h0c-.66,0-2.55.21-4.19.33h-.21c-.5.03-1.01.03-1.51,0-1.33-.18-2.61-.61-3.78-1.27-2.65-.4-5.26-1.02-7.81-1.87l-.44-.21-.41-.24c-.26-.17-.51-.36-.74-.57-.93-.77-1.72-1.7-2.34-2.74h0s-5.94-.26-13.99-.87c-3.01-.23-6.5-.53-9.99-.87-4.76-.47-8.7-.6-11.88-1.1l-.98-.18-1.13-.26c-.26-1.85-.07-3.73.56-5.49,1.18-3,3.65-5.31,6.72-6.3h0c1.88-.69,3.81-1.25,5.77-1.67h0l.81.35.84.36,1.18.51c6.83,2.94,14.74,6.5,20.11,7.96,1.61.42,3.24.71,4.9.86l1.51.12c5.8.39,11.53-.3,13.05-.21s5.23,3.62,7.54,5.8c.52.5,1.07.97,1.64,1.42l.18.14.14.12c.88.87,1.49,1.98,1.75,3.2h0c.12.4.2.82.24,1.24.08.16.13.32.17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m101.17,372.67s3.42,1.78,4.78,2.4,1.24,3.1,1.24,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.83,370.26c2.15,1.54,4.23,3.18,6.21,4.93.59.69.74,1.66.38,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m113.84,372.33c-1.78-1.91-3.67-3.72-5.65-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.34,280.12c-2.73,5.74-8.14,13.57-16.85,12.89-9.22-.78-14.41-7.28-16.81-11.39,3.32-1.27,6.68-2.56,9.44-3.65h0c0-2.8-.09-6.16-.39-9.5,0-.72-.15-1.51-.23-2.19s-.17-1.16-.26-1.72h17.53s-.11.69-.24,1.85h0c-.11,1.04-.24,2.43-.35,3.99-.14,2.08-.23,4.52-.17,6.83.84.29,1.7.6,2.56.93l1.66.57c.66.24,1.31.45,2,.68l1.51.45c.2.07.4.15.59.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m81.5,266.22s3.27,8.5,8.02,9.95,9.04-9.75,9.04-9.75c0,0-6.69,7.14-9.18,6.03s-7.85-6.16-7.85-6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.68,219.27c-4.43,3.99-7.94,8.89-10.29,14.36-2.16,4.52-3.98,9.72-2.32,14.45.99,2.35,2.4,4.5,4.14,6.36,3.26,3.9,7.82,14.8,11.08,18.7.21-6.95-5.61-18.18-4.99-24.01.75-4.51,2.23-8.86,4.39-12.89,2.19-5.28,5.06-10.26,8.53-14.8,1.97-2.38,8.32-6.62,1.91-7.13-4.25-.35-9.24,2.31-12.45,4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m74.58,242.96s-2.25-4.36-4.61-.23c-1.7,3.01.75,7.76,1.81,9.53.71,1.02,1.91,1.59,3.15,1.51l-.35-10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.09,258.7c-1.44,2.85-3.32,5.45-5.56,7.72l-1.36,1.4c-2.8,2.77-5.83,4.97-7.82,4.52-1.73-.35-3.99-2.13-6.21-4.4-.56-.56-1.1-1.16-1.64-1.76h0c-2.41-2.64-4.48-5.57-6.16-8.73-.47-1.18-.77-2.43-.89-3.69-.38-3.78-.51-7.57-.39-11.36v-3.01c0-2.62,9.83-11.74,9.83-11.74.26-.1.55-.13.83-.09,1.69.31,3.32.89,4.82,1.72,5.95,2.89,14.26,8.64,14.86,10.82.92,3.18.57,15.78-.3,18.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m84.57,246.61c0,1.06-.39,1.91-.83,1.91s-.87-.83-.87-1.91.39-1.94.87-1.94.83.89.83,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m95.8,244.68c.48,0,.87.86.87,1.93s-.39,1.91-.87,1.91-.87-.86-.87-1.91.39-1.93.87-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.97,241.86s1.51-3.01,6.84-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m100.76,241.86s-1.51-3.01-6.84-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m90.89,253.98c1.11-.07,2.05-.86,2.31-1.94,0,0-2.92-4.52-2.03-8.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m72.68,232.41c-1.21,1.65-2.13,3.49-2.71,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.28,220.35s-1.67,2.77-9.04,8.43c-.47.34-.93.72-1.36,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m61.65,308.72c-1,14.33-2.01,28.67-3.01,43.02v-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.86,261.41c2.77-1.08,5.89-.72,8.33.96,2.4,1.7,4.15,4.18,4.96,7.01.96,2.82.86,5.9-.27,8.65-1.2,2.77-3.82,4.65-6.83,4.9-2.2-.03-4.32-.8-6.03-2.19-5.64-4.22-8.46-15.77-.17-19.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m169.34,213.28c0,.18,0,1.37.11,1.58.53,2.32,1.64,8.12-1.18,9.3,1.07,3.81,3.69,28.73,3.35,41.43-.09,3.8-.75,8.3-4.16,9.93-5.74,2.73-11.2-3.92-10.55-9.12,1.01-7.1.66-14.33,1.51-21.51.92-7.45,2.61-15.07.75-22.35-.45-.5-3.35-6.24-4.3-7.82-.43-.68-.76-1.41-.99-2.17-.37-2.6-.55-5.23-.54-7.85.86-1.63,1.97-.12,2.56.95.48,1.3.64,2.7.48,4.08-.06.34,0,.68.14.99.26.36.69.56,1.13.51,1.85-.27,1.78-1.82,1.75-3.01v-11.95c0-.66.21-2.46.84-2.52s1.58.45,1.67,2.58c.11,2.4.11,9.78.11,9.78.12.12.3.17.47.14.15,0,.21-.27.27-.42.89-3.71,1.79-7.42,2.68-11.12.11-.44.75-1.34,1.22-1.34,1.12,0,1.15,1.3,1.21,1.67.39,1.99-2.4,10.19-2.86,12.06,0,.33,0,.83.35.74l4.37-8.82c.41-1.04,1.29-1.84,2.37-2.14.07-.02.15-.02.23,0,.08.05.14.11.18.2.42.75,0,1.79-.24,2.62s-3.51,6.92-4.67,9.37c-.17.35-.44,1.13-.11,1.51s.93-.35,1.18-.84c.74-1.51,1.43-2.92,2.11-4.4.21-.44.53-1.06,1.02-.95,2.94.63-1.24,6.8-2.44,8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m161.23,211.99c1.52,1.2,2.83,2.64,3.9,4.25,1.07,1.64,1.39,3.65.9,5.55-.07.24-.17.48-.29.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.77,306.15c1.6,3.22,2.67,6.67,3.18,10.22.44,3.56.57,6.35-1.85,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m84.75,225.37c-.21.62-.26,1.27-.15,1.91.29.81.81,1.51,1.51,2,4.82,4.22,10.21,7.74,16.01,10.46,1.51.39,2.47,1.87,2.22,3.41v11.65c.07,1.2-.04,2.41-.35,3.57-.84,2.71-2.71,4.9-4.07,7.4-1.38,2.37-2.08,5.08-2.02,7.82-.38-2.88,9.69-8.46,12.42-19.79.38-1.6,8.21-11.11,3.51-22.28-4.52-10.72-11.64-15.33-14.03-15.89-3.3-.96-6.86-.28-9.57,1.84-2.63,1.96-4.55,4.73-5.47,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m94.63,258.03c-.86.18-1.73.35-2.61.45-3.01.38-6.24-.09-8.21-2.29.15,1.97,1.51,9.44,5.56,9.65,4.05.21,5.26-7.81,5.26-7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.71,220.82c1.74,3.95,4.51,7.35,8.02,9.86,2.55,1.82,5.46,3.14,7.79,5.22,3.01,2.76,4.99,7.13,3.83,11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m122.21,281.71c-2.9,2.33-4.82,5.68-5.35,9.36-.52,3.18-.13,6.45,1.13,9.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.06,306.58c-.24,3.95-2.7,7.37-5.08,10.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m60.19,336.77c2.42,4.05,6.44,6.9,11.06,7.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.85,339.12s-4.05,6.03-17.83,7.29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-423"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m521.41,286.29s-52.53,16.28-62.41,3.42l1.34-65.58h7.97l9.37,46.2,43.05-7.88s5.52,17.09.68,23.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m499.29,288.59c-3.01,1.2-5.89,2.71-8.58,4.52,3.56,1.13,7.36-.3,10.91-1.43,4.7-1.44,9.49-2.57,14.33-3.38.23-1.34-1.51-4.4-2.19-5.59-1.24-2.08-1.51-2.26-3.59-1.24-3.78,1.9-7.01,5.2-10.9,7.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m521.41,286.29s-52.53,16.28-62.41,3.42l1.34-65.58h7.97l9.37,46.2,43.05-7.88s5.52,17.09.68,23.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m516.26,288.01l9.22,56.79c-.24,36.81,17.32,31.28,29.51,31.17,14.09-.12,35.48-14.09,24.99-35.84l4.04-78.72-24.55-1.87c-8.09-.63-41.25.41-43.89,4.64-6.84,10.99.68,23.83.68,23.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m517.71,292.7c5.48,20.72,18.62,38.6,36.76,50.01-1.96-.31-3.88-.86-5.71-1.64-1.84-.79-3.9-.9-5.82-.32-1.94.7-2.95,2.84-2.25,4.78,0,0,0,0,0,0,.44.71,1.04,1.3,1.75,1.73,2.99,2.1,6.26,3.78,9.72,4.97-3.03-.31-6.09-.08-9.04.69-.54,2.62,2.38,4.52,4.69,5.8,3.68,2.17,6.83,5.13,9.22,8.67-8.09.02-16.18.48-24.22,1.39-1.06.24-2.17.13-3.17-.3-1.04-.78-1.75-1.93-1.96-3.21-1.79-6.27-2.83-12.73-3.1-19.25-.15-3.66,0-7.36-.48-10.99-.39-2.86-.92-5.71-1.6-8.52-2.34-10.87-4.13-21.83-5.38-32.87-.56.05.59-.96.59-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m579.97,288.18c-2.03-.65-3.93-1.67-5.59-3.01.47,2.26,3.84,6.16,5.82,7.37.41.26.99.47,1.36.12s.6-1.24.96-1.51l-2.55-2.97Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m516.26,288.01l9.22,56.79c-.24,36.81,17.32,31.28,29.51,31.17,14.09-.12,35.48-14.09,24.99-35.84l4.04-78.72-24.55-1.87c-8.09-.63-41.25.41-43.89,4.64-6.84,10.99.68,23.83.68,23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m534.21,258.38c-2.64,4.84-3.91,10.3-3.68,15.81,0,.48.09.96.27,1.4.68,1.34,2.53,1.34,4.02,1.51,5.8.74,9.41,6.86,14.88,8.91.79.49,1.82.24,2.3-.55.01-.02.02-.04.03-.06,2.38-3.01,3.23-7.25,6.48-9.19,1.42-.84,3.21-1.19,4.19-2.52,1.12-1.51.62-3.68.08-5.52-.89-3.01-1.88-6.15-4.19-8.24-2.46-1.92-5.47-2.98-8.59-3.01-4.56-.37-9.15.06-13.57,1.27.06.57-2.23.2-2.23.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m607.16,296.92c-3.68-5.36-6.4-11.33-8.02-17.63-.59-3.16-1.51-6.24-2.74-9.21-2.36-4.64-6.76-7.91-11.89-8.82-1.08-.24-2.2-.19-3.26.15-2.19.83-3.15,3.35-3.59,5.64-.95,4.92-.67,10,.81,14.79,1.01,3.26,13.14,26.86,21.1,36.01-.69-4.61,4.61-20.03,7.58-20.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m583.36,292.29l7.45,14.03c1.07,2,2.28,4.14,4.36,5.02-1.31-4.64-2.05-9.41-2.22-14.23.08-2.42-.2-4.84-.83-7.17-.3.26-.62-.83-.62-.83-.33.62-1.21.63-1.88.5-4.87-1.02-8.21-5.37-11.11-9.41-.76,2.74-.21,5.68,1.51,7.96,0,0,3.1,3.66,3.35,4.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m607.16,296.92c-3.68-5.36-6.4-11.33-8.02-17.63-.59-3.16-1.51-6.24-2.74-9.21-2.36-4.64-6.76-7.91-11.89-8.82-1.08-.24-2.2-.19-3.26.15-2.19.83-3.15,3.35-3.59,5.64-.95,4.92-.67,10,.81,14.79,1.01,3.26,13.14,26.86,21.1,36.01-.69-4.61,4.61-20.03,7.58-20.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m596.7,313.8c-8.11-15.54-4.19-51.35-4.43-57.11l10.7-.57c1.07,0,6.03,30.54,9.41,43.21,3.01,11.55.12,23.23-5.22,23.23-4.43,0-8.76-5.49-10.46-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m500.07,273.45c7.54-11,22.32-11.88,22.32-11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m471,279.62c2.28-2.09,4.07-4.67,5.23-7.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m526.99,331.62c4.3,7.04,32.12,14.56,43.21,12.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m534.86,351.48c8.01,1.38,16.23,1.07,24.12-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m571.77,283.19l5.31,7.19c.72.98,1.73,2.08,2.92,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m611.2,555.91c-.47,1.91-.62,4.19.75,5.62,1.37,1.43,3.36,1.4,5.22,1.37l6.38-.12c2.46.12,4.92-.26,7.22-1.13,2.36-.92,3.9-3.21,3.84-5.74-.16-.96-.46-1.88-.9-2.74-.57-1.24-1.15-2.49-1.7-3.72-7.04-15.51-17.79-6.07-20.8,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m602.22,537.63c.22,7.12-.37,14.24-1.78,21.22-.33,1.58,0,3.98,1.51,3.83.59-.09,1.13-.4,1.51-.86,5.54-5.46,9.5-12.32,11.47-19.85.6-1.58.54-3.33-.17-4.87-.41-.61-.92-1.15-1.51-1.6-5.11-4.08-11.5-8.14-11.03,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m584.72,355.45s7.94,13.81,9.65,17.02,37.68,50.49,44.58,84.92c1.3,6.54-25.25,79.7-25.25,79.7l-6.03-3.41s4.19-66.73,3.17-72.27c-1.02-5.55-27.51-46.48-27.51-46.48,0,0-14.79-10.87-20.88-23.5l22.26-35.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m585.58,390.04s-4.52,10.07-4.52,11.52,24.87,80.03,32.18,98.21c4.62,11.71,8.7,23.68,12.22,35.93,5.29,18.37,2.83,3.72.69,7.54-2.14,3.81-10.66,6.32-12.4,2.91s-18.98-21.1-26.24-38.71c-7.26-17.6-17.48-47.03-23.3-57.98-7.62-14-14.39-28.45-20.26-43.27-7.31-18.7-14.79-38.87-14.79-38.87,3.04.27,6.09.36,9.13.26,7.17-.24,14.28-1.5,21.1-3.74,15.89-5.34,22.76-15.55,22.76-15.55,0,0,3.93,10.66,4.96,12.72l-1.54,29.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m636.3,464.12c-1.56,2.67-3.65,4.98-6.15,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m638.24,459.73c-.23.73-.5,1.45-.81,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m571.21,366.55c4.01,6.9,7.76,16.84,7.16,24.79-.32,1.45-.83,2.84-1.51,4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m546.95,374.23c.44,3.84,1.02,10.23.18,14-.71,3.85-2.92,7.27-6.15,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.13,359.68c.88,1.09,1.59,2.3,2.11,3.6,2.06,3.77,5.64,6.48,9.83,7.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m568.33,375.09c5.32,11.64,9.39,23.3,17.65,43.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m565.5,369.13c.45.9.89,1.81,1.33,2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m609.78,458.15c2.44,4.7,5.54,9.02,9.21,12.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m612.3,462.49c1.6,7.37,4.51,14.4,8.61,20.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m574.83,462.87c-11.74-25.05-24.27-49.9-39.66-87.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m577.48,470.15c-.29-.87-.59-1.75-.9-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m618.07,547.17c-3.01-3.93-24.99-34.67-30.45-48.59-3.63-9.28-6.38-15.84-9.04-25.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 609.78,
    y1: 488.02,
    x2: 620.23,
    y2: 518.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m602.74,256.14l-3.17.26c-4.01.71-8.13.52-12.06-.56-2.52-.62-8.35-2.43-9.04-2.55-1.73-.37-3.48-.65-5.25-.84-5.32-.32-2.62-2.31-.41-2.22,2.92.14,3.9.08,6.15.24-.27-.15-1.1-.32-1.12-.96,0-1.58,2.08-1.51,2.08-1.51,0,0-2.28-.96-1.96-2.16.32-1.19,1.84-1.51,2.8-1.42,0,0-1.28-.62-1.22-1.28.27-2.56,5.53-2.74,5.53-2.74-1.27-.57-2.46-1.3-3.54-2.19-.39-.42-.67-.94-.8-1.51-.09-.83.51-1.57,1.34-1.66.29-.03.57.02.83.15,1.36.91,2.67,1.88,3.93,2.92,1.63,1.16,3.51,1.9,5.23,2.94,1.67,1.43,3.03,3.21,3.96,5.2.27.42,6.69,9.87,6.69,9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m460.34,224.14v-8.3c-.02-4.17.59-8.31,1.81-12.3.69-2.2,1.51-4.11,2.25-4.4,1.37-.5,1.97,5.06,1.97,5.06-1.03-4.46-1.69-9-1.97-13.57,0-4.84,6.51,15.25,6.51,15.25l-2.59,18.25h-7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m468.21,210.63c.79-.61,1.38-1.44,1.69-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m531.33,241.45c2.82,4.74,4.37,10.12,4.52,15.63.27,9.16,10.88,21.99,13.91,22.61,3.03.62,5.83-14.47,5.7-19.04-.14-4.57-1.82-17.18-1.82-17.18,0,0-14.51-10.97-22.31-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m535.6,253.59s13.91,18.98,19.37-.32c5.46-19.29-15.3,5.28-19.37.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m559.08,239.95c-.74,11.26-5.88,17.59-11.8,18.7-5.41.99-13.32-4.52-17.27-12.71h0c-.3-.2-5.11-3.53-6.26-4.34-1.21-.85-1.94-2.24-1.93-3.72.08-1.43,1.02-2.68,2.38-3.14h.14c.68-.15,1.39-.1,2.03.15-.99-3.84-1.81-7.75-2.43-11.68.29-9.04,3.29-16.43,12.93-17.15,9.65-.72,17.71,4.67,18.09,8.56.27,3.01,1.25,10.99,2.13,19.23.24,2.14,2.16,3.56,1.99,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m554.97,226.92s-6.21-2.85-5.15,6.41c.21,1.82,3.6,4.52,3.6,4.52,0,0-.87,2.73-2.49,2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m542.97,230.09s-3.17-1.93-5.34-.74c-1.13.49-2.1,1.3-2.77,2.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m541.16,235.43c.24,1.12,0,2.11-.65,2.25s-1.28-.68-1.51-1.79c-.23-1.12,0-2.11.66-2.25s1.27.66,1.49,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m553.4,232.17c.24,1.12,0,2.11-.65,2.25s-1.28-.68-1.51-1.78,0-2.13.65-2.25,1.28.68,1.51,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m523.22,211.54c-1.1,1.08-1.87,2.46-2.2,3.96-1.82,6.44-.99,13.34,2.31,19.16,1-.12,2.02-.08,3.01.12,1.06.27,2.41,2.08,2.91,3.01.44,1,.69,2.06.74,3.15-.24-2.86-.47-5.71-.71-8.58-.16-1.15-.11-2.31.15-3.44h0c.74-2.35-.08-7.9.14-12.86,6.26,7.64,15.34,6.29,18.36,6.03,4.52-.38,8.38-5,8.14-8.3s-1.13-11.8-16.04-12.68c-3.28-.35-6.59.34-9.47,1.97-1.84,1.21-3.07,3.15-3.39,5.34-.21,1.39.32,1.51-.74,2.19s-2.17.03-3.21.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m542.97,245.89s2.22,2.44,6.84.83"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulherCelularHomem);
export default __webpack_public_path__ + "static/media/MulherCelularHomem.37758d85b7c7cacb38c93140ba3b3195.svg";
export { ForwardRef as ReactComponent };